module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-searchbox-rules"
    }
  }, [_c('hrms-search-box', {
    attrs: {
      "receivedStore": _vm.receivedStore,
      "nowLang": _vm.nowLang,
      "searchBoxAlias": _vm.searchBoxAlias
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c437ecc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoSearchboxRules.vue
// module id = 3973
// module chunks = 1